import * as styles from "./css/Backdrop.module.css";
const Backdrop = props => {
    return (<div class={`${styles.body}${props.centered ? ` ${styles.centered}` : ``}${props.dark ? ` ${styles.dark}` : ``}${props.class ? ` ${props.class}` : ``}`}>
            {props.children}
        </div>);
};
export { Backdrop };
